module.exports = require("regenerator-runtime");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/regenerator/index.js
 ** module id = 684
 ** module chunks = 0
 **/